'use client';

import { RecordAutoRefresh } from './RecordAutoRefresh';
import { useAutoRefreshOnNewVersion } from './useAutoRefreshOnNewVersion/useAutoRefreshOnNewVersion';

export function AutoRefreshOnNewVersionContainer({
  recordReload,
  pollIntervalMs,
}: {
  recordReload?: RecordAutoRefresh;
  pollIntervalMs?: number;
}) {
  useAutoRefreshOnNewVersion({ recordReload, pollIntervalMs });

  return undefined;
}
